import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class BillComService {

  constructor(private http: HttpClient, private utils: UtilsService) {}

  create_ach_profile(payload: any) {
    const url = `${environment.api}payment/billcom/create_ach_profile`;
    const formData: any = this.utils.jsonToFormData(payload);
    return this.http.post(url, formData);
  }

  charge_ach(payload: any) {
    const url = `${environment.api}payment/billcom/charge_ach`;
    const formData: any = this.utils.jsonToFormData(payload);
    return this.http.post(url, formData);
  }
}
